import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { featurePanelContext } from './featurePanelContext';
import { useState } from 'react';
import { FeaturePanel } from './FeaturePanel';
/**
 * Data provider for FeaturePanel's shared context.
 */
export const FeaturePanelProvider = ({ children, userInterface, featureList, }) => {
    const [isFeaturePanelOpen, setIsFeaturePanelOpen] = useState(false);
    const value = {
        isFeaturePanelOpen,
        setIsFeaturePanelOpen,
    };
    return (_jsxs(featurePanelContext.Provider, Object.assign({ value: value }, { children: [_jsx(FeaturePanel, { isFeaturePanelOpen: isFeaturePanelOpen, setIsFeaturePanelOpen: setIsFeaturePanelOpen, featureList: featureList, userInterface: userInterface }), children] })));
};
